import {
  START_GET_COLLECTION_LIST,
  SUCCESS_GET_COLLECTION_LIST,
  ERROR_GET_COLLECTION_LIST,
  START_DELETE_COLLECTION,
  SUCCESS_DELETE_COLLECTION_GROUP,
  ERROR_DELETE_COLLECTION_GROUP,
  START_GET_COLLECTION_COUNT,
  SUCCESS_GET_COLLECTION_COUNT,
  ERROR_GET_COLLECTION_COUNT,
  START_GET_COLLECTION_DETAIL,
  SUCCESS_GET_COLLECTION_DETAIL,
  ERROR_GET_COLLECTION_DETAIL,
  START_UPDATE_COLLECT_DATA,
  SUCCESS_UPDATE_COLLECT_DATA,
  ERROR_UPDATE_COLLECT_DATA,
  START_ADD_AND_UPDATE_NOTE,
  SUCCESS_ADD_AND_UPDATE_NOTE,
  ERROR_ADD_AND_UPDATE_NOTE,
  START_DELETE_NOTE,
  SUCCESS_DELETE_NOTE,
  ERROR_DELETE_NOTE,
  START_COLLECT_AND_REMOVE_MEDICATION,
  SUCCESS_COLLECT_AND_REMOVE_MEDICATION,
  ERROR_COLLECT_AND_REMOVE_MEDICATION,
  START_COLLECT_MARK_AS_URGENT,
  SUCCESS_COLLECT_MARK_AS_URGENT,
  ERROR_COLLECT_MARK_AS_URGENT,
  START_CREATE_RX,
  SUCCESS_CREATE_RX,
  ERROR_CREATE_RX,
  START_CREATE_CHASEUP,
  SUCCESS_CREATE_CHASEUP,
  ERROR_CREATE_CHASEUP,
  UPDATE_COLLECTION_DATA,
  START_GET_PRINT_COLLECTION_LIST,
  SUCCESS_GET_PRINT_COLLECTION_LIST,
  ERROR_GET_PRINT_COLLECTION_LIST,
  START_DRUG_NAME_UPDATE,
  SUCCESS_DRUG_NAME_UPDATE,
  ERROR_DRUG_NAME_UPDATE,
  START_UPDATE_FIELD_COLLECTION,
  SUCCESS_UPDATE_FIELD_COLLECTION,
  ERROR_UPDATE_FIELD_COLLECTION,
  SUCCESS_ARCHIVE_COLLECTION,
  START_ARCHIVE_COLLECTION,
  ERROR_ARCHIVE_COLLECTION,
  SUCCESS_COMPLETE_COLLECTION,
  ERROR_COMPLETE_COLLECTION,
  START_COMPLETE_COLLECTION,
  START_COLLECTED_AND_REMOVED_MEDICATION,
  SUCCESS_COLLECTED_AND_REMOVED_MEDICATION,
  ERROR_COLLECTED_AND_REMOVED_MEDICATION,
} from "Actions/CollectionAction";
import { ADD_NEW_NOTIFICATION } from "Actions/ConfigAction";
import {
  getCollectionListAPI,
  getCollectionCountAPI,
  deleteCollectionAPI,
  getCollectionViewRxDetailsAPI,
  updateCollectDataAPI,
  updateAddAndUpdateNoteAPI,
  deleteNoteAPI,
  collectAndRemoveAPI,
  markAsUrgentAPI,
  createRxAPI,
  createChaseup,
  updateDrugNameAPI,
  ArchiveCollectionAPI,
  CompleteCollectionAPI,
  collectedAndRemovedAPI,
} from "Api/CollectionApis";
import { updatePatientFieldAPI } from "Api/PatientApi";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

function* getColletionListWorker({ payload }) {
  try {
    const res = yield call(getCollectionListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_COLLECTION_LIST,
        payload: res,
        requestPayload: payload,
      });
    } else {
      yield put({
        type: ERROR_GET_COLLECTION_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getCollectionCountWorker({ payload }) {
  try {
    const res = yield call(getCollectionCountAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_COLLECTION_COUNT,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_COLLECTION_COUNT,
        payload: res,
      });
    }
  } catch (error) {}
}

function* archiveCollectionWorker({ payload }) {
  try {
    const res = yield call(ArchiveCollectionAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_ARCHIVE_COLLECTION,
        payload: res,
        id: payload,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message:
            payload?.is_archive === true
              ? "Archived successfully"
              : "Unarchived successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_ARCHIVE_COLLECTION,
        payload: res,
      });
    }
  } catch (error) {}
}

function* completeCollectionWorker({ payload }) {
  try {
    const res = yield call(CompleteCollectionAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_COMPLETE_COLLECTION,
        payload: res,
        id: payload,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Completed successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_COMPLETE_COLLECTION,
        payload: res,
      });
    }
  } catch (error) {}
}

function* deleteCollectionWorker({ id }) {
  try {
    const res = yield call(deleteCollectionAPI, id);
    if (res.success) {
      yield put({
        type: SUCCESS_DELETE_COLLECTION_GROUP,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "RX Deleted successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_DELETE_COLLECTION_GROUP,
        payload: res,
      });
    }
  } catch (error) {}
}

function* collectionoViewRXWorker({ id, payload }) {
  try {
    const res = yield call(getCollectionViewRxDetailsAPI, id, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_COLLECTION_DETAIL,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_COLLECTION_DETAIL,
        payload: res,
      });
    }
  } catch (error) {}
}

function* updateCollectDataWorker({ id, payload }) {
  try {
    const res = yield call(updateCollectDataAPI, id, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_UPDATE_COLLECT_DATA,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "RX updated successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_UPDATE_COLLECT_DATA,
        payload: res,
      });
    }
  } catch (error) {}
}

function* updateAddAndUpdateNoteDataWorker({ id, payload }) {
  try {
    const res = yield call(updateAddAndUpdateNoteAPI, id, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_ADD_AND_UPDATE_NOTE,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Rx Note Updated Successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_ADD_AND_UPDATE_NOTE,
        payload: res,
      });
    }
  } catch (error) {}
}

function* deleteNoteWorker({ id, payload }) {
  try {
    const res = yield call(deleteNoteAPI, id, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_DELETE_NOTE,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Rx Note Deleted Successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_DELETE_NOTE,
        payload: res,
      });
    }
  } catch (error) {}
}

function* collectedAndRemovedMedicationWorker({ id, payload }) {
  try {
    const res = yield call(collectedAndRemovedAPI, id, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_COLLECTED_AND_REMOVED_MEDICATION,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          // message: "All medications of RX has been collected.",
          message: res.message,
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_COLLECTED_AND_REMOVED_MEDICATION,
        payload: res,
      });
    }
  } catch (error) {}
}
function* collectAndRemoveMedicationWorker({ id, payload }) {
  try {
    const res = yield call(collectAndRemoveAPI, id, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_COLLECT_AND_REMOVE_MEDICATION,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          // message: "All medications of RX has been collected.",
          message: res.message,
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_COLLECT_AND_REMOVE_MEDICATION,
        payload: res,
      });
    }
  } catch (error) {}
}

function* markAsUrgentWorker({ id, payload }) {
  try {
    const res = yield call(markAsUrgentAPI, id, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_COLLECT_MARK_AS_URGENT,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: res.message,
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_COLLECT_MARK_AS_URGENT,
        payload: res,
      });
    }
  } catch (error) {}
}

function* createRxWorker({ payload }) {
  try {
    const res = yield call(createRxAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_CREATE_RX,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "RX added successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_CREATE_RX,
        payload: res,
      });
      // yield put({
      //   type: ADD_NEW_NOTIFICATION,
      //   payload: {
      //     message: res.message,
      //     type: "error",
      //   },
      // });
    }
  } catch (error) {}
}

function* updateChaseUpWorker({ payload, chaseUpActiveStatus }) {
  try {
    const res = yield call(createChaseup, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_CREATE_CHASEUP,
        payload: payload,
        response: res,
        chaseUpActiveStatus: chaseUpActiveStatus,
      });
      yield put({
        type: UPDATE_COLLECTION_DATA,
        payload: payload,
        chaseUpActiveStatus: chaseUpActiveStatus,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: res.message,
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_CREATE_CHASEUP,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: res.message,
          type: "error",
        },
      });
    }
  } catch (error) {}
}
function* getPrintCollectionListWorker({ payload }) {
  try {
    const res = yield call(getCollectionListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_PRINT_COLLECTION_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_PRINT_COLLECTION_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}
function* updateCollectionFieldWorker({ id, payload }) {
  try {
    const res = yield call(updatePatientFieldAPI, id, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_UPDATE_FIELD_COLLECTION,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Date Updated successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_UPDATE_FIELD_COLLECTION,
        payload: res,
      });
    }
  } catch (error) {}
}

function* updateDrugNameFieldWorker({
  id,
  payload,
  collectionId,
  collectionPayload,
}) {
  try {
    const res = yield call(updateDrugNameAPI, id, payload);
    if (res?.success) {
      const res = yield call(
        getCollectionViewRxDetailsAPI,
        collectionId,
        collectionPayload
      );
      if (res.success) {
        yield put({
          type: SUCCESS_GET_COLLECTION_DETAIL,
          payload: res,
        });
      }
      yield put({
        type: SUCCESS_DRUG_NAME_UPDATE,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Drug Updated successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_DRUG_NAME_UPDATE,
        payload: res,
      });
    }
  } catch (error) {}
}
export function* CollectionSaga() {
  yield takeLatest(START_GET_COLLECTION_LIST, getColletionListWorker);
  yield takeEvery(START_GET_COLLECTION_COUNT, getCollectionCountWorker);
  yield takeEvery(START_DELETE_COLLECTION, deleteCollectionWorker);
  yield takeEvery(START_GET_COLLECTION_DETAIL, collectionoViewRXWorker);
  yield takeEvery(START_UPDATE_COLLECT_DATA, updateCollectDataWorker);
  yield takeEvery(START_ADD_AND_UPDATE_NOTE, updateAddAndUpdateNoteDataWorker);
  yield takeEvery(START_DELETE_NOTE, deleteNoteWorker);
  yield takeEvery(
    START_COLLECT_AND_REMOVE_MEDICATION,
    collectAndRemoveMedicationWorker
  );
  yield takeEvery(
    START_COLLECTED_AND_REMOVED_MEDICATION,
    collectedAndRemovedMedicationWorker
  );

  yield takeEvery(START_COLLECT_MARK_AS_URGENT, markAsUrgentWorker);
  yield takeEvery(START_CREATE_RX, createRxWorker);
  yield takeEvery(START_CREATE_CHASEUP, updateChaseUpWorker);
  yield takeEvery(START_DRUG_NAME_UPDATE, updateDrugNameFieldWorker);
  yield takeEvery(
    START_GET_PRINT_COLLECTION_LIST,
    getPrintCollectionListWorker
  );
  yield takeEvery(START_UPDATE_FIELD_COLLECTION, updateCollectionFieldWorker);
  yield takeEvery(START_ARCHIVE_COLLECTION, archiveCollectionWorker);
  yield takeEvery(START_COMPLETE_COLLECTION, completeCollectionWorker);
}
